import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiAxios } from '@/lib/apiAxios';
const fetchWorkspacePageDesigns = async (workspaceId) => apiAxios.get(`/workspaces/${workspaceId}/page-designs`).then((response) => response.data);
export const useWorkspacePageDesigns = (workspaceId) => useQuery({
    queryKey: ['page-designs', 'workspace', workspaceId],
    queryFn: () => fetchWorkspacePageDesigns(workspaceId),
    enabled: Boolean(workspaceId),
    staleTime: 60_000,
});
const postWorkspacePageDesign = ({ workspaceId, data }) => apiAxios.post(`/workspaces/${workspaceId}/page-designs`, data).then((response) => response.data);
export const useSaveAsDesign = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: postWorkspacePageDesign,
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['page-designs', 'workspace', variables.workspaceId] });
        },
    });
};
const deleteWorkspacePageDesign = ({ workspaceId, publicId }) => apiAxios.delete(`/workspaces/${workspaceId}/page-designs/${publicId}`).then((response) => response.data);
export const useDeleteWorkspacePageDesign = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteWorkspacePageDesign,
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['page-designs', 'workspace', variables.workspaceId] });
        },
    });
};
/** Map a workspace-design DTO to the unified PageDesign shape used by the
 *  picker. All three themed modes (classic / feedback / showroom) consume
 *  tokens now, so the workspace design can apply to any of them. proOnly
 *  stays false: the user already has Pro to create it.
 *  picker. supportedModes is `['showroom']` only — that's the single mode
 *  whose Twig template currently consumes design tokens. When classic /
 *  feedback templates start reading tokens, persist `supportedModes` on
 *  WorkspacePageDesign and round-trip it instead of widening this list
 *  (otherwise old workspace designs leak into modes they were never tested
 *  against). proOnly stays false: the user already has Pro to create it.
 */
export const mapWorkspaceDesign = (d) => ({
    id: d.publicId,
    source: 'workspace',
    supportedModes: ['showroom', 'classic', 'feedback'],
    proOnly: false,
    previewImage: d.previewImageUrl,
    name: d.name,
    description: d.description ?? '',
    tokens: d.tokens,
});
